import { SxProps } from "@mui/material";

export const DRAWER_WIDTH = 280;
export const TOP_NAV_HEIGHT = 60;
export const PAGE_HEADER_HEIGHT = 60;
export const ROW_STYLES: SxProps = {
  display: "flex",
  alignItems: "center",
  gap: 1,
};

export const FLEX_BETWEEN_STYLES: SxProps = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

export const FLEX_CENTER_STYLES: SxProps = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const PAGE_HEADER_ICON_STYLES: SxProps = { minWidth: 0, width: 40 };
